import { strRemoveSpace, strToHash } from "./string";

export const hasBeenTemplateDiff = (prevHtml: string, html: string) => {
  const prev = prevHtml.trim().toLowerCase();
  const now = html.trim().toLowerCase();

  return strToHash(strRemoveSpace(prev)) !== strToHash(strRemoveSpace(now));
};
